/* eslint-disable react/no-array-index-key -- every key below indexes a
   static array built fresh inside one synchronous render pass (the
   source string's own line split, or one line's **bold** split) and never
   reordered/filtered/mutated afterward — the one case index keys are
   actually fine. Same exception OpportunityDetails.jsx's own copy of this
   component carried before this file was extracted from it. */
/* eslint-disable react/require-default-props -- defaultProps on function
   components is deprecated as of React 18.3 (console warning, removed in
   19), so this file uses a plain JS default parameter instead — same
   reasoning AutoCollapseButton.jsx's own copy of this exception documents. */
import React from 'react';
import PropTypes from 'prop-types';

// Lightweight line-based markdown renderer for the limited subset of syntax
// job/requirement descriptions actually use (#/##/### headers, - bullet
// lists, **bold** inline) — extracted from OpportunityDetails.jsx (its own
// original home) once JobPostingDetail.jsx needed the exact same rendering
// for its own detailed_job_description field, rather than duplicating this
// ~100-line parser a second time. Renders real React elements (no
// dangerouslySetInnerHTML), unlike the separate MarkdownViewer/MarkdownEditor
// pair (src/components/common/) used elsewhere in the app for
// HTML-contentEditable-backed fields — this one is specifically for
// plain-text markdown source with no editor counterpart.
const MarkdownBody = ({ source = '' }) => {
  if (!source) return null;
  const lines = source.split('\n');
  const out = [];
  let listBuf = [];

  const renderInline = (text) =>
    text.split(/(\*\*[^*]+\*\*)/).map((part, i) =>
      part.startsWith('**') && part.endsWith('**') ? (
        <strong
          key={i}
          className="text-foreground-strong"
          style={{ fontWeight: 650 }}
        >
          {part.slice(2, -2)}
        </strong>
      ) : (
        part || null
      )
    );

  const flushList = (key) => {
    if (!listBuf.length) return;
    out.push(
      <ul key={`ul-${key}`} style={{ paddingLeft: 18, margin: '4px 0 10px' }}>
        {listBuf.map((item, i) => (
          <li
            key={i}
            className="text-muted-foreground"
            style={{ fontSize: 13, lineHeight: 1.65, marginBottom: 2 }}
          >
            {renderInline(item)}
          </li>
        ))}
      </ul>
    );
    listBuf = [];
  };

  lines.forEach((line, i) => {
    if (/^###\s/.test(line)) {
      flushList(i);
      out.push(
        <h3
          key={i}
          className="text-foreground-strong"
          style={{ fontSize: 13, fontWeight: 700, margin: '14px 0 5px' }}
        >
          {renderInline(line.slice(4))}
        </h3>
      );
    } else if (/^##\s/.test(line)) {
      flushList(i);
      out.push(
        <h2
          key={i}
          className="text-foreground-strong"
          style={{
            fontSize: 14,
            fontWeight: 700,
            margin: '18px 0 6px',
            letterSpacing: '-0.01em',
          }}
        >
          {renderInline(line.slice(3))}
        </h2>
      );
    } else if (/^#\s/.test(line)) {
      flushList(i);
      out.push(
        <h1
          key={i}
          className="text-foreground-strong"
          style={{
            fontSize: 15,
            fontWeight: 750,
            margin: '0 0 8px',
            letterSpacing: '-0.02em',
          }}
        >
          {renderInline(line.slice(2))}
        </h1>
      );
    } else if (/^[-*]\s/.test(line)) {
      listBuf.push(line.slice(2));
    } else if (line.trim() === '') {
      flushList(i);
    } else {
      flushList(i);
      out.push(
        <p
          key={i}
          className="text-muted-foreground"
          style={{ fontSize: 13, lineHeight: 1.65, margin: '0 0 8px' }}
        >
          {renderInline(line)}
        </p>
      );
    }
  });
  flushList('end');

  return <div>{out}</div>;
};

MarkdownBody.propTypes = {
  source: PropTypes.string,
};

export default MarkdownBody;
